import { render, staticRenderFns } from "./AdminReferalMain.vue?vue&type=template&id=3aa66ee5"
import script from "./AdminReferalMain.vue?vue&type=script&lang=js"
export * from "./AdminReferalMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports